import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import './css/impressao.css';
import API from '../../../actions/api-helper';
import UI from '../../../actions/ui-helper';
import DataUtil from '../../../actions/data.js';
import StringUtil from '../../../actions/string.js';

class ImpressaoProducao extends Component {
  constructor(props) {
    super(props);
    this.state = false;
    if (this.props.location) {
      this.state = this.props.location.state;
    }
  }

  componentDidMount() {
    if (!this.state) return;
    UI.loader('show', 'Aguarde, gerando relatório...');
    API.post('/apuracao/producao', this.state)
      .then(json => {
        this.setState({ periodo: json.data });
        UI.loader('hide');
      })
      .catch(json => {
        UI.alert(false, json.message);
      });
  }

  render() {
    if (!this.state) {
      this.props.history.push('/relatorio/producao');
      return false;
    }
    if (!this.state.periodo) {
      return false;
    }

    let fontePequena = {
      fontSize: '10px',
    };
    let styleProcedimento = {
      width: '30%',
    };
    let styleAssinatura = {
      width: '45%',
      margin: '8px',
      marginTop: '100px',
      display: 'inline-block',
      borderTop: '1px solid black',
      textAlign: 'center',
      verticalAlign: 'top',
    };
    let styleAssinaturaEsquerda = {
      width: '50%',
      display: 'inline-block',
    };
    let styleAssinaturaDireita = {
      display: 'inline-block',
      width: '50%',
      textAlign: 'right',
    };
    let styleLabel = {
      width: '10%',
      fontWeight: '700',
      display: 'inline-block',
    };

    // Dados do cabeçalho
    let periodo = this.state.periodo;
    let empresa = this.props.usuario.empresa;
    let endereco = this.props.usuario.empresa.endereco;
    let tipoRelatorio = parseInt(this.state.tipo);
    let nomeRelatorio =
      tipoRelatorio === 0
        ? 'Geral'
        : tipoRelatorio === 1
        ? 'Atendimentos'
        : 'Atividades / Reuniões';

    // Juntar atendimentos em grupo
    let data = false;
    let horaEntrada = false;
    let producaoAcima =
      this.state.periodo.producao.length > 0 ? this.state.periodo.producao[0] : false;
    let totalMinutos = 0;

    this.state.periodo.producao.map((producao, i) => {
      if (parseInt(this.state.tipo) !== 0 && producao.tipo !== parseInt(this.state.tipo)) {
        return false;
      }
      // Criar o atributo
      if (!producao.span) {
        producao.span = 1;
      }
      // Juntar
      if (data === producao.data && horaEntrada === producao.horaEntrada) {
        if (producaoAcima) {
          producaoAcima.span++;
          producao.span = 0;
        } else {
          producaoAcima = producao;
          producaoAcima.span = 2;
        }
      } else {
        data = producao.data;
        horaEntrada = producao.horaEntrada;
        producaoAcima = producao;

        // Calcular o total dos minutos (mover para o backend)
        if (producao.tipoAtendimento !== 3) {
          totalMinutos +=
            parseInt(producao.horaTotal.substring(0, 2)) * 60 +
            parseInt(producao.horaTotal.substring(3, 5));
        }
      }
      return true;
    });

    // Renderização da tabela
    return (
      <div className="report">
        <button className="btn btn-primary btn-float-right" onClick={() => window.print()}>
          <i className="icon icon-printer" />
          Preparar para Impressão
        </button>
        <header className="report-header">
          <h2>{empresa.razaoSocial}</h2>
          <h3>CNPJ: {empresa.cnpj}</h3>
          <h4>
            {endereco.logradouro} {endereco.numero} - {endereco.bairro} - cep {endereco.cep} -{' '}
            {endereco.cidade} - {endereco.estado}
          </h4>
          <h3>
            RELATÓRIO DE PRODUÇÃO - {this.state.periodoDe} - {this.state.periodoAte}
          </h3>
        </header>
        <hr />
        <div className="report-content">
          <p>
            <span style={styleLabel}>Nome:</span>
            {periodo.profissional ? periodo.profissional.nome : 'TODOS'}
            <br />
            <span style={styleLabel}>Setor:</span>
            {periodo.profissional ? periodo.profissional.setor : 'TODOS'}
            <br />
            <span style={styleLabel}>Empresa:</span>
            {empresa.razaoSocial}
            <br />
            <span style={styleLabel}>Período:</span>
            {periodo.periodoDe} até {periodo.periodoAte}
            <br />
            <span style={styleLabel}>Tipo:</span>
            {nomeRelatorio}
          </p>
          <br />
          <table className="report-table stretch" style={fontePequena}>
            <thead>
              <tr>
                <th>Data</th>
                <th>Entrada</th>
                <th>Saida</th>
                <th>Total</th>
                <th style={styleProcedimento}>Cód / Procedimento</th>
                <th>Descrição</th>
                <th>Data Nascimento</th>
                <th>Cidade</th>
                {tipoRelatorio === 0 || tipoRelatorio === 1 ? <th>Paciente</th> : null}
                <th>Profissional</th>
                {tipoRelatorio === 0 || tipoRelatorio === 1 ? <th>Atendim.</th> : null}
              </tr>
            </thead>
            <tbody>
              {this.state.periodo.producao.map((producao, i) => {
                if (
                  parseInt(this.state.tipo) !== 0 &&
                  producao.tipo !== parseInt(this.state.tipo)
                ) {
                  return false;
                }
                let prefixoDescricao =
                  producao.tipo === 2
                    ? 'ATA ' + (producao.id < 10 ? '0' : '') + producao.id + ' '
                    : '';
                return (
                  <tr key={i}>
                    {producao.span > 0 && [
                      <td
                        key={'0_' + i}
                        style={{ pageBreakInside: 'avoid' }}
                        rowSpan={producao.span}
                      >
                        {producao.data}
                      </td>,
                      <td key={'1_' + i} rowSpan={producao.span}>
                        {producao.horaEntrada.substring(0, 5)}
                      </td>,
                      <td key={'2_' + i} rowSpan={producao.span}>
                        {producao.horaSaida.substring(0, 5)}
                      </td>,
                      <td key={'3_' + i} rowSpan={producao.span}>
                        {producao.horaTotal.substring(0, 5)}
                      </td>,
                    ]}
                    <td>
                      {producao.procedimento.codigo} - {producao.procedimento.descricao}
                    </td>
                    <td>{prefixoDescricao + producao.descricao}</td>
                    <td>{producao.paciente ? producao.paciente.dataNascimento : ''}</td>
                    <td>{producao.paciente ? producao.paciente.endereco.cidade : ''}</td>
                    {tipoRelatorio === 0 || tipoRelatorio === 1 ? (
                      <td>
                        {producao.paciente
                          ? producao.paciente.idCismepar + ' - ' + producao.paciente.nome
                          : ''}
                      </td>
                    ) : (
                      ''
                    )}
                    <td>
                      {producao.valores.map((valor, i) => {
                        let last = producao.valores.length - 1;
                        let separador = i + 1 === last ? ' e ' : i + 1 < last ? ', ' : '';
                        return (
                          <span key={i}>
                            {valor.usuario.nome.toUpperCase()}
                            {separador}
                          </span>
                        );
                      })}
                    </td>
                    {tipoRelatorio === 0 || tipoRelatorio === 1 ? (
                      <td>{StringUtil.tipoAtendimento(producao.tipoAtendimento)}</td>
                    ) : (
                      ''
                    )}
                  </tr>
                );
              })}
              <tr>
                <td>
                  <b>TOTAL</b>
                </td>
                <td />
                <td />
                <td>{DataUtil.formatarHora(totalMinutos)}</td>
                <td />
                <td />
                <td />
                <td />
                {tipoRelatorio === 0 || tipoRelatorio === 1 ? <td /> : null}
                <td />
                {tipoRelatorio === 0 || tipoRelatorio === 1 ? <td /> : null}
              </tr>
            </tbody>
          </table>
          <br />
          <p>Londrina, {DataUtil.dataPorExtenso(DataUtil.hoje())}</p>
          <div>
            <div style={styleAssinaturaEsquerda}>
              <div style={styleAssinatura}>
                {periodo.profissional.nome}
                <br />
                Carimbo
              </div>
            </div>
            <div style={styleAssinaturaDireita}>
              <span style={styleAssinatura}>
                Gerente Coordenador da Unidade
                <br />
                Carimbo
              </span>
              <span style={styleAssinatura}>
                Diretor do Serviço
                <br />
                Carimbo
              </span>
            </div>
          </div>
        </div>
        <footer className="report-footer">
          <span id="pageCount" />
        </footer>
      </div>
    );
  }
}

export default withRouter(ImpressaoProducao);
